import { type FilterValues } from "components/filters/FilterContext";
import { mapAppointPhaseFilterToInstruction, mapArtistFilterToInstruction, mapPeriodFilterToInstruction, mapProductionFilterToInstruction, mapResponseToAppointmentPhaseFilter, mapResponseToArtistFilter, mapResponseToPeriodFilter, mapResponseToProductionFilter } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.ListShowExternalInstruction => ({
  artistIds: mapArtistFilterToInstruction(filter.artist),
  productionIds: mapProductionFilterToInstruction(filter.production),
  phases: mapAppointPhaseFilterToInstruction(filter.appointmentPhase),
  period: mapPeriodFilterToInstruction(filter.period),
  page,
  perPage,
  cache: filterSet
});

export const mapResponseToFilterValues = (
  response: server.dto.ListShowExternalFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  artist: mapResponseToArtistFilter(response.artists),
  production: mapResponseToProductionFilter(response.productions),
  appointmentPhase: mapResponseToAppointmentPhaseFilter(response.phases),
  period: mapResponseToPeriodFilter(response.period)
});